export default __webpack_public_path__ + "static/media/msync1.56b29beb.png";